import React from "react";
import { ReactComponent as ChatIcon} from "assets/icons/chat.svg";
import s from "./new-chat.module.scss";

const NewChat = (props) => {

    const handleButtonClick = (defaultText) => {
        props.checkDefault(props.getValue(defaultText));
    }

    const defaulTextButton = [
        'ANALYZE_TONE',
        'FIND_CONTRADICTIONS',
        'TRENDS_IN_MEDIA',
        'COMPARE_REACH'
    ]

    //const buttons = defaulTextButton.map((k, i) => <button key={i} onClick={handleButtonClick.bind(this, k)} className={s.defaultButton}>{props.getValue(k)}</button>)

    return (
        <div className={s.NewChat}>
            <div className={s.ChatIcon}>
                <ChatIcon />
            </div>
            <div className={s.chatDescription}>
                <h3>{ props.getValue('ECHO_AI_ASSISSTENT') }</h3>
                <p>{ props.getValue('ASK_QUESTION_TO_MEDIA') }</p>
            </div>
            {/*<div className={s.defaultButtonsBlock}>
                { buttons}
            </div>*/}
        </div>
    )
}

export default NewChat;